import { includes } from "lodash";
import React from "react";
import { DragAndDropCrossMatch } from "./DragAndDropCrossMatch";
import { DragAndDropFillinQuestion } from "./DragAndDropFillinQuestion";
import { OrderDragDrop } from "./OrderDragDrop";

export const QuestionType = {
  DragAndDropCrossMatch: "DragAndDropCrossMatch",
  DragAndDropFillinQuestion: "DragAndDropFillinQuestion",
  DragAndDropOptionsMisleading: "DragAndDropOptionsMisleading",
  DragAndDropParagraphOrdering: "DragAndDropParagraphOrdering",
  DragAndDropOptionsSorting: "DragAndDropOptionsSorting",
};

export const DragAndDropRunner = ({
  question,
  exercise_id,
  section_id,
  page_id,
  data_possible_type,
  isShowNumbering,
  qai,
  answer,
  isReview,
  Questionedit,
  data,
  isBlinking,
  focusblink,
  blurblink,
  setIsBlinking,
  isFielddisabled
}) => {


  const trimedString = question.prompt_content.trim();
  const converted = trimedString.replace(
    /\[\[[^\]]*\]\]/g,
    function replacer(matched) {
      if (includes(matched, "options_place_holder")) {
        return `<span data-type="options_place_holder" type="text" className="form-control-sm"></span>`;
      } else {
        return `<span data-type="${
          question.type
        }" type="text" className="form-control-sm" data-id ="${matched.match(
          /\d+/
        )}"  ></span>`;
      }
    }
  );
  return (
    <div>
      {question.type === QuestionType.DragAndDropCrossMatch ? (
        <div class="mb-3">
          <DragAndDropCrossMatch
            converted={converted}
            exercise_id={exercise_id}
            section_id={section_id}
            page_id={page_id}
            data_possible_type={data_possible_type}
            question={question}
            isShowNumbering={isShowNumbering}
            qai={qai}
            answer={answer}
            isReview={isReview}
            Questionedit={Questionedit}
            data={data}
            isBlinking={isBlinking}
            setIsBlinking={setIsBlinking}
            focusblink={focusblink}
            blurblink={blurblink}
            isFielddisabled={isFielddisabled}
          />
        </div>
      ) : question.type === QuestionType.DragAndDropFillinQuestion || question.type === QuestionType.DragAndDropOptionsMisleading ? (
        <div class="mb-3">
          <DragAndDropFillinQuestion
            converted={converted}
            question={question}
            exercise_id={exercise_id}
            section_id={section_id}
            page_id={page_id}
            data_possible_type={data_possible_type}
            isShowNumbering={isShowNumbering}
            qai={qai}
            answer={answer}
            isReview={isReview}
            data={data}
            Questionedit={Questionedit}
            isBlinking={isBlinking}
            setIsBlinking={setIsBlinking}
            focusblink={focusblink}
            blurblink={blurblink}
            isFielddisabled={isFielddisabled}
          />
        </div>
      ) : question.type === QuestionType.DragAndDropOptionsSorting ? (
        <OrderDragDrop
          exercise_id={exercise_id}
          section_id={section_id}
          page_id={page_id}
          data_possible_type={data_possible_type}
          question={question}
          qai={qai}
          answers={answer}
          isReview={isReview}
          Questionedit={Questionedit}
        />
      ) : null}
    </div>
  );
};
